module.exports = __webpack_public_path__ + "assets/images/green-xmas-scrollyimage3.jpg?v=e48588cb";